module.exports = __webpack_public_path__ + "static/media/elo.7a55a79b.svg";